module.exports = __webpack_public_path__ + "img/next.51ad37bd.svg";